<template>
  <ul v-if="visitCount || !hiddenZero || visitCountOther" class="visit-count">
    <li v-if="visitCount || !hiddenZero">{{ formatExceed(visitCount) }}</li>
    <li v-if="visitCountOther" class="another">他 {{ formatExceed(visitCountOther) }}</li>
  </ul>
</template>

<script>
import { formatExceed } from '@/utils/number'

/**
 * 来店回数
 */
export default {
  name: 'VisitCount',
  props: {
    /** 来店回数 */
    visitCount: { type: Number },
    /** 他店の来店数 */
    visitCountOther: { type: Number },
    /** ゼロを非表示 */
    hiddenZero: { type: Boolean, default: false },
  },
  methods: {
    formatExceed,
  },
}
</script>

<style lang="postcss" scoped>
.visit-count {
  color: var(--text-color);
  display: flex;

  li {
    background: var(--white);
    border: 1px solid var(--dark-gray-1);
    border-radius: 8px;
    box-sizing: border-box;
    font-size: 12px;
    height: 16px;
    line-height: 1.2;
    margin-left: 8px;
    min-width: 32px;
    padding: 0 2px;
    text-align: center;

    &.another {
      min-width: 40px;
    }
  }
}
</style>
